import { QueryClient } from "@tanstack/react-query";

// App-wide TanStack Query client. Tuned for the board's read model, which is the first consumer:
// - retry off — board reads already route failures through KMainFunctions.exceptionHandler
//   (a toast); silent auto-retries would hide that and double the load on a failing backend.
// - refetchOnWindowFocus off — liveness comes from the board events SSE stream + explicit
//   invalidation, not focus polling, so we avoid surprise refetches/flicker on tab switches.
// - a short staleTime so a remounting view reuses the cache for a beat instead of refetching,
//   while event-driven invalidation remains the real freshness mechanism.
export const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 10_000,
      cacheTime: 5 * 60_000
    }
  }
});
